import { Editor, Element, Transforms } from 'slate';
/**
 * All nodes matching `isConvertibleToListTextNode()` in the current selection
 * will be converted to list items and then wrapped in lists.
 *
 * @see ListsEditor.isConvertibleToListTextNode()
 */
export function wrapInList(editor, listType) {
  if (!editor.selection) {
    return;
  }
  var nonListEntries = Array.from(Editor.nodes(editor, {
    at: editor.selection,
    match: node => {
      return Element.isElement(node) && !editor.isListNode(node) && !editor.isListItemNode(node) && !editor.isListItemTextNode(node) && editor.isConvertibleToListTextNode(node);
    }
  }));
  var refs = nonListEntries.map(_ref => {
    var [_, path] = _ref;
    return Editor.pathRef(editor, path);
  });
  refs.forEach(ref => {
    var path = ref.current;
    if (path) {
      Editor.withoutNormalizing(editor, () => {
        Transforms.setNodes(editor, editor.createListItemTextNode(), {
          at: path
        });
        Transforms.wrapNodes(editor, editor.createListItemNode(), {
          at: path
        });
        Transforms.wrapNodes(editor, editor.createListNode(listType), {
          at: path
        });
      });
    }
    ref.unref();
  });
}